import React from 'react';
import PropTypes from 'prop-types';

import { getTextInputType } from './helpers';
import TextArea from '../../input-fields/text-area';
import TextField from '../../input-fields/text-field';
import RadioButtonGroup from '../../input-fields/radio-button-group';
import CheckboxGroup from '../../input-fields/checkbox-group';
import Select from '../../input-fields/select';
import fieldTypes from '../../form/field-types';
import FileUpload from '../file-upload/dropzone';
import AutoSuggest from '../auto-suggest';
import FieldLabel from './label';

const InputType = React.forwardRef(
  ({ type, inputProps, labelProps, value }, ref) => {
    if (!type) return null;

    let input = null;
    let label = <FieldLabel {...labelProps} />;

    switch (type) {
      case fieldTypes.CHECKBOXES:
        label = null;
        input = (
          <CheckboxGroup
            {...inputProps}
            values={value}
            isControlled
            ref={ref}
            legend={<FieldLabel {...labelProps} as="legend" />}
          />
        );
        break;
      case fieldTypes.DROPDOWN:
        input = <Select {...inputProps} placeholder ref={ref} />;
        break;
      case fieldTypes.RADIO_BUTTONS:
        label = null;
        input = (
          <RadioButtonGroup
            {...inputProps}
            defaultValue={inputProps.value}
            value={value}
            ref={ref}
            legend={<FieldLabel {...labelProps} as="legend" />}
          />
        );
        break;
      case fieldTypes.AUTO_SUGGEST:
        input = <AutoSuggest {...inputProps} ref={ref} />;
        break;
      case fieldTypes.TEXT_AREA:
        input = <TextArea {...inputProps} value={value} ref={ref} />;
        break;
      case fieldTypes.FILE_UPLOAD:
        label = null;
        input = (
          <FileUpload
            {...inputProps}
            label={labelProps.label}
            value={value}
            ref={ref}
          />
        );
        break;
      default:
        if (getTextInputType(type)) {
          input = (
            <TextField
              {...inputProps}
              type={getTextInputType(type)}
              value={value}
              ref={ref}
            />
          );
        }
    }

    return (
      <>
        {label && label}
        {input}
      </>
    );
  }
);

InputType.displayName = 'InputType';

InputType.propTypes = {
  type: PropTypes.string,
  inputProps: PropTypes.object,
  labelProps: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default InputType;
